module.exports = __webpack_public_path__ + "static/media/lifescience.6e0a00d9.png";